export const adminColors = {
    white: '#ffffff',
    blue: '#3182f6',
    blueDark: '#1b64da',
    blueHover: 'rgba(49, 130, 246, 0.06)',
    blueSelected: 'rgba(49, 130, 246, 0.12)',
    gray50: '#f9fafb',
    gray100: '#f2f4f6',
    gray200: '#e5e8eb',
    gray300: '#d1d6db',
    gray400: '#b0b8c1',
    gray500: '#8b95a1',
    gray600: '#6b7684',
    gray700: '#4e5968',
    gray900: '#191f28',
    green: '#00c73c',
    greenDark: '#00a832',
    greenLight: '#e6f8ed',
    greenBorder: '#b9ebc9',
    orange: '#ff8a00',
    orangeDark: '#e06f00',
    orangeLight: '#fff4e6',
    orangeBorder: '#ffd8a8',
    cyan: '#00a3ff',
    cyanDark: '#0077c2',
    cyanLight: '#e8f6ff',
    cyanBorder: '#bee4ff',
    red: '#f04452',
    redDark: '#991b1b',
    redLight: '#fef2f2',
    redBorder: '#fecaca',
}

export const adminRadii = {
    control: 4,
    surface: 6,
}

export const adminShadows = {
    appBar: '0 1px 2px rgba(15, 23, 42, 0.08)',
    surface: '0 1px 3px rgba(15, 23, 42, 0.08)',
    floating: '0 8px 24px rgba(15, 23, 42, 0.14)',
    modal: '0 24px 64px rgba(15, 23, 42, 0.22)',
}

export const adminBorders = {
    subtle: 'rgba(148, 163, 184, 0.24)',
    strong: adminColors.gray600,
}

export const adminTransitions = {
    fast: '120ms ease',
    normal: '150ms ease',
}
